<template>
    <div id="app" class="h-fix">
        <component :is="layout" />
    </div>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { isEmpty } from 'lodash';
    import AuthLayout from './layouts/Auth.vue';
    import DefaultLayout from './layouts/Default.vue';

    export default {
        components: {
            AuthLayout,
            DefaultLayout,
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            layout() {
                const layout = this.$route.meta.layout || 'default';

                return `${layout}-layout`;
            },
        },

        watch: {
            'authUser.locale': {
                immediate: true,
                handler(newValue) {
                    if (!newValue) {
                        return;
                    }

                    this.$i18n.locale = newValue;
                },
            },

            'authUser.timezone': {
                immediate: true,
                handler(newValue) {
                    if (!newValue) {
                        return;
                    }

                    moment.tz.setDefault(newValue);
                },
            },
        },

        methods: {
            ...mapActions([
                'fetchAuthUser',
                'clearAuthUser',
            ]),

            ...mapMutations([
                'setAuthUser',
            ]),

            async refreshUser() {
                if (this.$route.meta.auth) {
                    return;
                }

                const authUser = JSON.parse(sessionStorage.getItem('authUser'));

                if (isEmpty(authUser)) {
                    this.clearAuthUser();
                    return;
                }

                try {
                    await this.fetchAuthUser(authUser.email);
                } catch (error) {
                    this.clearAuthUser();
                }
            },
        },

        mounted() {
            this.refreshUser();
        },
    };
</script>
